import React from "react";
import './InfoIcon.css';

const InfoIcon = ({ size = 20, color = 'grey', tooltip='' }) => {
  return (
    <div className="info-icon-wrapper">
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', cursor: 'pointer' }}
    >
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none" />
      <line x1="12" y1="16" x2="12" y2="12" stroke={color} strokeWidth="2" />
      <circle cx="12" cy="8" r="1" fill={color} />
    </svg>
    {tooltip && <div className="tooltip">{tooltip}</div>}
    </div>
  );
};

export default InfoIcon;
